export const CIPP_V1ResourcesBS: CIPP_V1ResourcesBSInterface = {
  labelDone: "Datum obavljanja zadatka",
  evidencijaForm: {
    buttonForward: "Potpisi",
    buttonBack: "Nazad",
  },
  successModal: {
    title: "Unos podataka",
    body: "Dodavanje podataka je uspješno završeno. Odaberite OK za nastavak.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "Odabirom opcije Potpiši potvrđujem da je zadatak izvršen prema uputstvu!",
  errors: {
    recordAlreadyExists:
      "Ova evidencija je već popunjena. Ne možete je popuniti ponovo.",
  },
};

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

export interface CIPP_V1ResourcesBSInterface {
  labelDone: string;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: {
    recordAlreadyExists: string;
  };
}
